function copyOfferCode(code, btn) {
    if (!navigator.clipboard) {
      // fallback for older browsers
      const textarea = document.createElement('textarea');
      textarea.value = code;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
      } catch (e) {}
      document.body.removeChild(textarea);
    } else {
      navigator.clipboard.writeText(code);
    }

    // Show alert message
    const alertBox = document.getElementById('offer-card-alert');
    if (alertBox) {
      alertBox.classList.add('show');
      setTimeout(function () {
        alertBox.classList.remove('show');
      }, 1500);
    }
  }